import { render, staticRenderFns } from "./LoginCard.vue?vue&type=template&id=8852af9a&scoped=true"
import script from "./LoginCard.vue?vue&type=script&lang=js"
export * from "./LoginCard.vue?vue&type=script&lang=js"
import style0 from "./LoginCard.vue?vue&type=style&index=0&id=8852af9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8852af9a",
  null
  
)

export default component.exports